import type { Map as LeafletMap } from "leaflet";
import type { PrintRenderContext } from "./printRenderScale";

export interface PrintLayerAdapter {
  id: string;
  apply: (context: PrintRenderContext) => void | Promise<void>;
  restore: () => void | Promise<void>;
}

export type PrintLayerAdapterFactory = () => PrintLayerAdapter;

const factoriesByMap = new WeakMap<LeafletMap, Set<PrintLayerAdapterFactory>>();

export const registerPrintLayerAdapter = (
  map: LeafletMap,
  factory: PrintLayerAdapterFactory
): (() => void) => {
  let factories = factoriesByMap.get(map);

  if (factories == null) {
    factories = new Set();
    factoriesByMap.set(map, factories);
  }

  factories.add(factory);

  return () => {
    factories?.delete(factory);
  };
};

export const snapshotPrintLayerAdapters = (
  map: LeafletMap
): PrintLayerAdapter[] => {
  const factories = [...(factoriesByMap.get(map) ?? [])];

  return factories.map((factory) => factory());
};
